import React from 'react'
import styled from 'styled-components'
import {
  Switch,
  Redirect,
} from 'react-router-dom'
import RoutePassChildren from '../../RoutePassChildren'
import Annual from './Annual'
import Monthly from './Monthly'

const Container = styled.div`
  padding: 30px 0 60px;
`

export default (props) => (
  <Container>
    <Switch>
      <RoutePassChildren path='/results/annual' exact component={Annual} childrenProps={props} />
      <RoutePassChildren path='/results/monthly' exact component={Monthly} childrenProps={props} />
      <Redirect from='/results' to='/results/annual' />
    </Switch>
  </Container>
)
